import type { DataProfile } from './CompanyProfile.types';

const BASE_VIDEO_URL = 'https://www.globaldatabase.com/storage/base';

export const data: DataProfile[] = [
  {
    title: 'Company Profile',
    videoUrl: `${BASE_VIDEO_URL}/payg/company_profile.mp4`,
    items: [
      'Companies',
      'Directors/Officers',
      'Registered address',
      'VAT ID',
      'Registration number',
      'LEI number',
      'Incorporation date',
      'Status',
      'SIC/NAICS codes',
      'Legal Form',
      'Banking information',
    ],
  },
  {
    title: 'Firmographic Data',
    videoUrl: `${BASE_VIDEO_URL}/payg/firmographic_data.mp4`,
    items: [
      'Websites',
      'Social Media Profiles',
      'Business Description',
      'Industry tags',
      'Employee numbers',
      'Revenue',
      'Company phone numbers',
      'Company emails',
    ],
  },
  {
    title: 'Group Structure',
    videoUrl: `${BASE_VIDEO_URL}/business_credit_reporting/corporate_hierarchy_knowledge.mp4`,
    items: [
      /** */
      'Parent company',
      'Subsidiaries',
      'Location',
      'Registration ID',
      'VAT number',
      'LEI',
    ],
  },
  {
    title: 'Shareholders/UBO',
    videoUrl: `${BASE_VIDEO_URL}/sales_&_marketing/campaigns_that_convert.mp4`,
    items: [
      'Full name',
      'Date of birth',
      'Nationality',
      'Number of shares held',
      'Value of shares',
      'Total value',
      'Correspondence address',
    ],
  },
  {
    title: 'Financial Overview',
    videoUrl: `${BASE_VIDEO_URL}/financial_reporting/unified_platform.mp4`,
    items: [
      'Balance sheet',
      'Income statement',
      'Profit and Loss',
      'Cash flow',
      'KPI & Ratios',
      'Original PDF documents',
    ],
  },
  {
    title: 'Credit Risk',
    videoUrl: `${BASE_VIDEO_URL}/business_credit_reporting/credit_score_and_limits.mp4`,
    items: [
      'Credit score',
      'Credit Limit recommendation',
      'Trade payment data',
      'Court Judgement',
      'Mortgages and Charges',
    ],
  },
];
